/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon16Solid = forwardRef('UiMenuDots3HIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.502 8A1.499 1.499 0 1 0 4.5 8a1.499 1.499 0 0 0-2.998 0Z" }),
        React.createElement("path", { d: "M8 9.499A1.499 1.499 0 1 1 8 6.5a1.499 1.499 0 0 1 0 2.998Z" }),
        React.createElement("path", { d: "M13.001 9.499a1.499 1.499 0 1 1 0-2.998 1.499 1.499 0 0 1 0 2.998Z" })));
});
